import Header from "../../components/AppHeader";
import Dot from "../../components/Dot";
import Icon from "../../components/Icon";
import ModalScheduleLogistic from "../../components/ModalScheduleLogistic";
import PageContainer from "../../components/PageContainer";
import SubscriptionModal from "../../components/SubscriptionModal";
import theme from "../../configs/theme-config";
import { CartRetrieveOutput } from "../../ducks/cart/cart-types";
import useCart from "../../ducks/cart/hooks/useCart";
import useProfile from "../../ducks/user/hooks/useProfile";
import {
  EVENT_TYPES,
  logEvent,
  logMetrixEvent,
  METRIX_EVENT_TYPES,
} from "../../helpers/analytics-helper";
import { iosSafeArePadding } from "../../helpers/general";
import { scheduledDateTitle } from "../../helpers/logistics-helper";
import { contentGenerator } from "../../helpers/logistics-helper";
import { formatCartItems } from "../../helpers/normalizer";
import useSaveBasket from "../../hooks/useSaveBasket";
import { LogisticScheduledTask } from "../../types/server";
import BasketInvoiceNew from "../BasketInvoiceNew";
import OrderListInBasket from "../OrderListInBasket";
import Section from "../Section";
import {
  Box,
  Divider,
  Stack,
  Button,
  Spacer,
  Typography,
  LogisticsHistory,
  CouponInput,
  useToast,
} from "digiwash-components";
import { formatNumber } from "digiwash-core";
import React, { useState, useEffect, useContext } from "react";
import { SafeAreaView, Platform, TouchableOpacity } from "react-native";
import { services_to_ga_cart } from "../../helpers/ga-helper";
import HeaderContainer from "../HeaderContainer";
import Loading from "../../components/Loading";
import { CreditContext } from "../../contexts/credit";
import useNavigation from "../../hooks/useNavigation";
import { useListenToDeepLinks } from "../../hooks/useListenToDeepLinks";
import useFocusEffect from "../../hooks/useFocusEffect";
import useSyncFilterWithParam from "../../hooks/useSyncFilterWithParam";

let nativeStyles = {
  container: {
    width: "100%",
    backgroundColor: "white",
    position: "absolute",
    bottom: 0,
    left: 0,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
    elevation: 9,
  },
  bar: {},
};

let webStyles = {
  container: {
    position: "fixed",
    paddingHorizontal: 12,
    paddingVertical: 16,
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    boxShadow: "0px 0px 4px rgba(33, 33, 33, 0.16)",
    maxWidth: 768,
    zIndex: 1,
    alignItems: "center",
  },
  bar: {
    backgroundColor: "#fff",
    maxWidth: 768,
    margin: "auto",
    width: "100%",
    border: "1px solid #ccc",
    borderBottom: "",
    borderTopRightRadius: "16px",
    borderTopLeftRadius: "16px",
  },
};
let overrideStyles = Platform.OS === "web" ? webStyles : nativeStyles;
let styles = {
  ...overrideStyles,
};

let Container = Platform.OS === "web" ? Box : SafeAreaView;

function Cart() {
  let nav = useNavigation();
  let toast = useToast();
  let { params, reset } = useSyncFilterWithParam();
  let added_address = params?.added_address;
  let { retrieve: retrieveCart, revalidateCart, coupon } = useCart();
  let cart: CartRetrieveOutput = retrieveCart({ force: true });
  let cartData = cart?.data;
  let { data, workspaces, revalidate: revalidateProfileData } = useProfile();
  let credit = data ? data.total_balance : 0;
  let needsToPay = cartData?.legacyQuote.total_price > credit;
  let { check_and_save_collection } = useListenToDeepLinks();
  let [scheduledCollectionTask, setSelectedCollectionTask] =
    useState<LogisticScheduledTask>();

  let [viewCartEventSent, setViewCartEventSent] = useState(false);
  let [loadingCoupon, setLoadingCoupon] = useState(false);

  let hasWorkspace = workspaces?.list?.length > 1;

  let [modalVisibility, setModalVisibility] = useState(false);
  let { setCreditModalOpen, setPrefilledValue } = useContext(CreditContext);

  let [openModal, setOpenModal] = useState(false);
  let orderID;
  if (cartData?.id) {
    let [, id] = cartData?.id.split("_");
    orderID = Number(id);
  }
  let { save, loading } = useSaveBasket("collection", {
    order_id: orderID,
  });
  let scheduledLogistic = scheduledCollectionTask;
  let formattedCartItems = cartData && formatCartItems(cart.data);

  let couponReduction = !cart.loading
    ? cartData?.legacyQuote.discount
    : undefined;
  let activeWorkspaceName =
    workspaces &&
    workspaces.activeWorkspace?.id != "personal" &&
    workspaces.activeWorkspace?.agreement &&
    workspaces.activeWorkspace?.agreement?.promotion_code
      ? workspaces.activeWorkspace?.name
      : null;

  let actionButtonText = "ثبت سفارش";

  async function removeCouponAndRevalidateCart() {
    try {
      await coupon.remove();
    } catch (error) {
      let errorMessage = error;
      if (!errorMessage) {
        errorMessage = "مشکلی در حذف کد تخفیف پیش آمده است.";
      }
      throw errorMessage;
    }
    try {
      await revalidateCart();
    } catch {
      throw "کد حذف شد. مشکل در دریافت سبد خرید.";
    }
  }

  async function addCouponAndRevalidateCart(code: string) {
    try {
      await coupon.add(code);
      toast.show("کد تخفیف با موفقیت افزوده شد.", {
        data: { type: "success" },
      });
      logEvent(EVENT_TYPES.BUTTON_ADD_COUPON);
    } catch (error) {
      let errorMessage = error;
      if (!errorMessage) {
        errorMessage = "مشکلی در افزودن کد تخفیف پیش آمده است.";
      }
      throw errorMessage;
    }
    try {
      await revalidateCart();
    } catch {
      throw "کد با موفقیت افزوده شد. مشکل در دریافت سبد خرید.";
    }
  }

  let dismissModal = () => {
    setModalVisibility(false);
    if (Platform.OS === "web") {
      reset("added_address");
    } else if (Platform.OS === "android") {
      added_address = false;
    }
  };

  function generateLogisticTask(data = scheduledLogistic) {
    let content = contentGenerator("collection", data);
    let output = [];

    if (!!data) {
      let task = {
        address_latitude: 0,
        address_longitude: 0,
        address_text: data?.address.address_text,
        driver: undefined,
        id: 0,
        period: {
          id: data?.period.id,
          date: data?.period.date,
          start: data?.period.start,
          end: data?.period.end,
          title: content.time,
        },
        status: "unassigned",
        task_type: "collection",
      };

      output.push(task);
    }

    return output;
  }

  function refreshData() {
    revalidateProfileData().then(([profile]) => {
      let total_balance = profile.total_balance ? profile.total_balance : 0;

      let needsToPay = cartData?.legacyQuote.total_price > total_balance;
      if (!needsToPay) {
        check_and_save_collection({
          cart: cart,
          needsToPay: needsToPay,
        });
      }
    });
  }

  useEffect(() => {
    if (cartData && !viewCartEventSent) {
      logEvent(
        EVENT_TYPES.VIEW_CART,
        services_to_ga_cart(cartData.legacyQuote.total_price, cartData.services)
      );
      setViewCartEventSent(true);
    }
  }, [cartData]);

  useEffect(() => {
    if (cart.error) {
      toast.show(cart.error, {
        data: { type: "danger" },
      });
    }
  }, [cart.error]);

  useFocusEffect(
    React.useCallback(() => {
      if (!loading) {
        refreshData();
      }
    }, [loading])
  );

  useEffect(() => {
    if (
      !!workspaces.activeWorkspace?.agreement?.promotion_code &&
      !cartData?.legacyPromotion.code
    ) {
      setLoadingCoupon(true);
      addCouponAndRevalidateCart(
        workspaces.activeWorkspace.agreement.promotion_code
      ).finally(() => {
        setLoadingCoupon(false);
      });
    }
  }, []);
  let walletAmount = Number(data?.balance) + Number(data?.gift_balance);

  useEffect(() => {
    if (added_address === "true") {
      setModalVisibility(true);
    }
  }, [added_address]);
  return (
    <PageContainer
      bg="neutrals.250"
      insideBeignScrollView={
        <HeaderContainer>
          <Header
            title="تکمیل سفارش"
            onBack={() => {
              nav.navigate("Home");
            }}
          />
        </HeaderContainer>
      }
      afterScrollView={
        scheduledLogistic ? (
          <Stack style={{ width: "100%" }} distribution="center">
            <Container style={styles.container}>
              <Stack
                style={{
                  width: "100%",
                  paddingBottom: iosSafeArePadding(),
                }}
                distribution="space-between"
              >
                <Stack style={{ flexGrow: 1 }}>
                  <Button
                    fill="primary"
                    style={{
                      width: "100%",
                    }}
                    onPress={() => {
                      save({
                        address_id: scheduledLogistic.address.id,
                        period_id: scheduledLogistic.period.id,
                        meta: {
                          address: scheduledLogistic.address.address_text,
                          time: scheduledDateTitle(scheduledLogistic),
                        },
                      }).then(() => {
                        let event_meta = {};
                        logEvent(
                          EVENT_TYPES.BEGIN_CHECKOUT,
                          services_to_ga_cart(
                            cartData?.legacyQuote.total_price,
                            cartData?.services,
                            cartData?.legacyPromotion?.code
                          )
                        );
                        logMetrixEvent(
                          METRIX_EVENT_TYPES.COLLECTION,
                          event_meta
                        );
                      });
                    }}
                    loading
                    disabled={
                      !scheduledLogistic ||
                      cartData?.items.length === 0 ||
                      loading
                    }
                  >
                    {actionButtonText}
                  </Button>
                </Stack>
              </Stack>
            </Container>
          </Stack>
        ) : null
      }
    >
      <Stack
        direction="vertical"
        alignment="stretch"
        bg="neutrals.250"
        pt="xxl"
      >
        {!cart.loading && !cartData && cart.error ? (
          <Stack distribution="center" pt="xxxl">
            <Typography>{cart.error}</Typography>
          </Stack>
        ) : null}

        <>
          <Section
            title="سفارش‌ شما"
            subTitle={
              <Typography fs="l" ff="mainBold" color="neutrals.850">
                {formatNumber(cart?.data?.services.length)} مورد
              </Typography>
            }
            icon="ordersBasket"
          >
            {cart.loading ? (
              <Box p="xxxl">
                <Loading color="primary.main" />
              </Box>
            ) : null}
            {!cart.loading && !!cart.data ? (
              <Stack px="m" direction="vertical" alignment="stretch">
                <OrderListInBasket items={formattedCartItems} />
              </Stack>
            ) : null}
          </Section>
          <Divider size="xxl" />
          <Divider size="xxl" />

          <Section title="حمل و نقل" icon="truck">
            {cart.loading ? (
              <Box p="xxxl">
                <Loading color="primary.main" />
              </Box>
            ) : null}
            {!cart.loading && !!cart.data ? (
              <Box p="l">
                <LogisticsHistory
                  status={
                    !!scheduledLogistic
                      ? "ready_to_collect"
                      : "submitted_by_customer"
                  }
                  list={generateLogisticTask()}
                  onAdd={() => setModalVisibility(true)}
                  onReschedule={() => setModalVisibility(true)}
                  icons={{
                    normal: <Dot />,
                    active: <Dot active />,
                  }}
                  theme={theme}
                  policy="customer"
                />
              </Box>
            ) : null}
            <ModalScheduleLogistic
              selectedAddressAndTimesheet={
                scheduledLogistic
                  ? {
                      address_id: scheduledLogistic.address.id,
                      address_text: scheduledLogistic.address.address_text,
                      period: scheduledLogistic.period,
                    }
                  : undefined
              }
              type="collection"
              visible={modalVisibility}
              dismissModal={dismissModal}
              onAction={(selectedAddress, selectedTimesheet) => {
                setSelectedCollectionTask({
                  period: selectedTimesheet,
                  address: selectedAddress,
                });
                dismissModal();
              }}
              origin_page="Basket"
            />
          </Section>
          <Divider size="xxl" />
          <Divider size="xxl" />

          <Section
            title="صورتحساب"
            icon="receipt"
            subTitle={
              hasWorkspace ? (
                <Stack>
                  <TouchableOpacity
                    onPress={() => {
                      setOpenModal(!openModal);
                    }}
                  >
                    <Box>
                      <Stack>
                        <Box>
                          <Typography color="gray.light950" fs="s">
                            {workspaces &&
                            workspaces.activeWorkspace?.id === "personal"
                              ? "حساب شخصی"
                              : "گروه کاربری"}
                          </Typography>
                          <Typography fs="xm" color="common.black">
                            {workspaces
                              ? workspaces.activeWorkspace?.name
                              : null}
                          </Typography>
                        </Box>
                        <Spacer size="xl" />
                        <Icon name="chevron-down" size={15} />
                      </Stack>
                    </Box>
                  </TouchableOpacity>
                </Stack>
              ) : null
            }
          >
            {cart.loading ? (
              <Box p="xxxl">
                <Loading color="primary.main" />
              </Box>
            ) : null}
            {!cart.loading && !!cart.data ? (
              <Box pt="xxxl" px="l">
                <Box>
                  <CouponInput
                    theme={theme}
                    code={cartData?.legacyPromotion.code}
                    switchGroupsIsLoading={
                      workspaces.changeActiveWorkspaceIsLoading
                    }
                    loading={loadingCoupon}
                    onRemove={() => {
                      setLoadingCoupon(true);
                      return removeCouponAndRevalidateCart().finally(() => {
                        setLoadingCoupon(false);
                      });
                    }}
                    onAdd={(couponInput) => {
                      setLoadingCoupon(true);
                      return addCouponAndRevalidateCart(couponInput).finally(
                        () => {
                          setLoadingCoupon(false);
                        }
                      );
                    }}
                    workspaceName={activeWorkspaceName}
                    reduction={couponReduction}
                    errorRenderer={(messages) => {
                      return (
                        <>
                          <Divider size="m" />
                          {messages.map(
                            (
                              message: {
                                type: string;
                                text: string;
                                color: string;
                              },
                              index
                            ) => {
                              return (
                                <Stack pr="l" key={index}>
                                  <Icon
                                    name="alert-circle"
                                    color={message.color}
                                    size={20}
                                  />

                                  <Spacer size="s" />
                                  <Typography color={message.color} fs="s">
                                    {message.text}
                                  </Typography>
                                </Stack>
                              );
                            }
                          )}
                        </>
                      );
                    }}
                  />
                </Box>
                <Divider size="l" />
                <BasketInvoiceNew
                  invoice={cartData?.legacyQuote}
                  bg="common.white"
                  walletAmount={walletAmount}
                />
              </Box>
            ) : null}
          </Section>
          <Divider size="xxxl" />
          <Divider size="xl" />
        </>
      </Stack>

      {hasWorkspace ? (
        <SubscriptionModal
          workspaces={workspaces.list}
          activeWorkspace={workspaces.activeWorkspace.id}
          onSelect={(selectWorkspace) => {
            workspaces.changeActiveWorkspace(selectWorkspace);
            setOpenModal(false);
          }}
          onDismiss={() => {
            setOpenModal(false);
          }}
          isModalOpen={openModal}
        />
      ) : null}
    </PageContainer>
  );
}

export default Cart;
